import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

const LOTTIE_PATH = '/lottie/9fe12c24-1178-11ee-be5f-830c8b48a4db.json';

const HeroLottie = () => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    fetch(LOTTIE_PATH)
      .then((res) => res.json())
      .then(setAnimationData)
      .catch(console.error);
  }, []);

  if (!animationData) {
    return <div className="hero-lottie hero-lottie--loading" aria-hidden="true" />;
  }

  return (
    <Lottie
      className="hero-lottie"
      animationData={animationData}
      loop
    />
  );
};

export default HeroLottie;
